import { useResizeObserver } from '@react-hookz/web/useResizeObserver/index.js';
import { usePathname } from 'next/navigation';
import type { RefObject } from 'react';
import { memo, useCallback, useRef, useState } from 'react';
import { Link } from '#components/Link/Link';
import { useBreakpoint } from '#cutils/hooks/useBreakpoint';
import type { NavigationList as NavigationListType } from '#cutils/page-context/navigation';
import styles from './HighlightNavigation.module.scss';
type Props = {
  highlightNavigation: NavigationListType;
  onBayernMenuClick?: () => void;
  bayernButtonRef: RefObject<HTMLButtonElement | undefined>;
  className?: string;
  hideBayernMenu: boolean;
};
export const HighlightNavigation = memo(function HighlightNavigation({
  highlightNavigation,
  onBayernMenuClick,
  className,
  bayernButtonRef,
  hideBayernMenu
}: Props) {
  const isDesktop = useBreakpoint('lg');
  const navigationContainerRef = useRef<HTMLElement>(null);
  const elementsRef = useRef<(HTMLElement | undefined)[]>([]);
  const [elementsHidden, setElementsHidden] = useState<boolean[]>([]);
  const registerNavigationItem = useCallback((element: HTMLElement | null, index: number) => {
    if (element) {
      elementsRef.current[index] = element;
    } else {
      elementsRef.current[index] = undefined;
    }
  }, []);

  // Hides invisible highlight navigation nodes to avoid for them being accessible via keyboard navigation
  useResizeObserver(navigationContainerRef, (event: ResizeObserverEntry) => {
    const {
      bottom: navigationBottom,
      right: navigationRight
    } = event.target.getBoundingClientRect();
    let hiddenStateChanged = false;
    const newState = new Array(elementsHidden.length);
    for (let i = 0; i < elementsRef.current.length; i++) {
      const element_0 = elementsRef.current[i];
      if (element_0) {
        const {
          bottom,
          right
        } = element_0.getBoundingClientRect();
        if (right > navigationRight || bottom > navigationBottom) {
          newState[i] = true;
        } else {
          newState[i] = false;
        }
        hiddenStateChanged ||= newState[i] !== elementsHidden[i];
      }
    }
    if (hiddenStateChanged) {
      setElementsHidden(newState);
    }
  }, isDesktop);
  const pathname = usePathname();
  function handleBayernButtonRef(element_1: HTMLButtonElement) {
    bayernButtonRef.current = element_1;
  }
  return <nav className={`${styles.highlightNavigation} ${className ?? ''}`} ref={navigationContainerRef}
  // tracking attributes
  data-t-element="top_navigation" data-t-type="Highlightnavigation">
			{!hideBayernMenu ? <button className={`${styles.link} heading4 button-link`} onClick={onBayernMenuClick} ref={handleBayernButtonRef}>
					Bayern
				</button> : null}
			{highlightNavigation.map((navigationNode, index_0) => {
      const isLinkActive = pathname === navigationNode.link;
      return <Link href={navigationNode.link} key={navigationNode.id} className={`${styles.link} ${isLinkActive ? styles.active : ''} ${elementsHidden[index_0] ? styles.hidden : ''}`} ref={element_2 => registerNavigationItem(element_2, index_0)} target={navigationNode.isExternal ? '_blank' : undefined}>
						{navigationNode.title}
					</Link>;
    })}
		</nav>;
});